var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"7"}},[_c('CategoriesTable')],1),_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('LocalCategoriesTable')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }